import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout for all routes nested under $pinId (groups variant).
// Group container renders the pin independently via useParams({ strict: false }).
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/$planId/$pinId'
)({
  component: () => <Outlet />
})
